import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import ProjectHeader from './ProjectHeader'
import PaymentView from './PaymentView'
import DevView from './DevView'
import { STEP } from '../projectStepManager'

function ClientDevPaymentView(props) {
    var nums = props.nums
    var pg = props.pg
    var safeContract = props.safeContract || {}

    var displayStep = props.displayStep

    var mainTitle =
        nums === 5
            ? displayStep === STEP.DEPOSIT
                ? STEP.DEPOSIT
                : displayStep === STEP.DEV1
                ? STEP.DEV1
                : displayStep === STEP.DEV1_RECEIVE
                ? STEP.DEV1_RECEIVE
                : displayStep === STEP.DEV1_APPROVE
                ? STEP.DEV1_APPROVE
                : '1단계 개발 보고서'
            : nums === 6
            ? displayStep === STEP.MIDDLE
                ? STEP.MIDDLE
                : displayStep === STEP.DEV2
                ? STEP.DEV2
                : displayStep === STEP.DEV2_RECEIVE
                ? STEP.DEV2_RECEIVE
                : displayStep === STEP.DEV2_APPROVE
                ? STEP.DEV2_APPROVE
                : '2단계 개발 보고서'
            : nums === 7
            ? displayStep === STEP.FINAL_REPORT
                ? STEP.FINAL_REPORT
                : displayStep === STEP.FINAL_REPORT_RECEIVE
                ? STEP.FINAL_REPORT_RECEIVE
                : displayStep === STEP.FINAL_REPORT_APPROVE
                ? STEP.FINAL_REPORT_APPROVE
                : displayStep === STEP.FINAL_PAY
                ? STEP.FINAL_PAY
                : '3단계 개발 보고서'
            : '개발'
    var paymentLabel = nums === 5 ? '선금 납부' : nums === 6 ? '중도금 납부' : nums === 7 ? '잔금 납부' : '납부'

    var reportLabel =
        nums === 5
            ? '1단계 개발 보고서'
            : nums === 6
            ? '2단계 개발 보고서'
            : nums === 7
            ? '3단계 개발 보고서'
            : '개발 보고서'

    var hasReport =
        nums === 5
            ? !!safeContract.develop1
            : nums === 6
            ? !!safeContract.develop2
            : nums === 7
            ? !!safeContract.develop3
            : false

    var isCurrentPaymentStep =
        (nums === 5 && displayStep === STEP.DEPOSIT) ||
        (nums === 6 && displayStep === STEP.MIDDLE) ||
        (nums === 7 && displayStep === STEP.FINAL_PAY)

    // var reportFirst = nums === 7

    const [paymentOpen, setPaymentOpen] = useState(isCurrentPaymentStep || !hasReport)
    const [reportOpen, setReportOpen] = useState(hasReport && !isCurrentPaymentStep)

    useEffect(
        function () {
            setPaymentOpen(isCurrentPaymentStep || !hasReport)
            setReportOpen(hasReport && !isCurrentPaymentStep)
        },
        [hasReport, isCurrentPaymentStep, nums],
    )
    function renderPaymentSection() {
        return (
            <SectionBlock>
                <AccordionHeader
                    type="button"
                    onClick={function () {
                        setPaymentOpen(!paymentOpen)
                    }}
                >
                    <span>{paymentLabel}</span>
                    <Arrow>{paymentOpen ? '접기 ▲' : '펼치기 ▼'}</Arrow>
                </AccordionHeader>

                {paymentOpen ? (
                    <AccordionBody>
                        {/* <PaymentView {...props} paymentLabel={paymentLabel} hideHeader={true} clientMode={true} /> */}
                        <PaymentView
                            {...props}
                            paymentLabel={paymentLabel}
                            paymentOnly={nums === 5 ? 'deposit' : nums === 6 ? 'middle' : 'final'}
                            hideHeader={true}
                            clientMode={true}
                        />
                    </AccordionBody>
                ) : null}
            </SectionBlock>
        )
    }

    function renderReportSection() {
        return (
            <SectionBlock>
                <AccordionHeader
                    type="button"
                    onClick={function () {
                        setReportOpen(!reportOpen)
                    }}
                >
                    <span>{reportLabel}</span>
                    <Arrow>{reportOpen ? '접기 ▲' : '펼치기 ▼'}</Arrow>
                </AccordionHeader>

                {reportOpen ? (
                    <AccordionBody>
                        {hasReport ? <DevView {...props} hideHeader={true} clientMode={true} /> : <EmptyReport />}
                    </AccordionBody>
                ) : null}
            </SectionBlock>
        )
    }

    return (
        <ClientDevPaymentRoot>
            <ProjectHeader pg={pg} viewTitle={mainTitle} />

            {renderPaymentSection()}
            <Divider />
            {renderReportSection()}
        </ClientDevPaymentRoot>
    )
}

export default ClientDevPaymentView

const ClientDevPaymentRoot = styled.div`
    width: 100%;
`

const SectionBlock = styled.div`
    width: 100%;
`

const AccordionHeader = styled.button`
    width: 100%;
    height: 50px;
    padding: 0 22px;
    border: 1px solid #1baacc;
    border-radius: 10px;
    background: #f4fbfd;
    color: #111;
    font-size: 18px;
    font-weight: 800;
    cursor: pointer;

    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;

    &:hover {
        background: #eaf8fb;
    }
`

const Arrow = styled.span`
    position: absolute;
    right: 22px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 13px;
    font-weight: 700;
    color: #1baacc;
`

const AccordionBody = styled.div`
    margin-top: 18px;
`

const Divider = styled.div`
    width: 100%;
    height: 1px;
    background: #000;
    margin: 40px 0;
`

const EmptyReport = styled.div`
    min-height: 0;
`
